export const urlTarget = (url: string) => (url.startsWith('https') ? '_blank' : '_self');
